import { MARKETTYPE } from '../constants/bakery/nft'

export function userMintMarketType(nftType?: string) {
  let marketType = ''
  switch(nftType){
    case '111,3':
      marketType = MARKETTYPE.BAKERYBSCARTWORK
      break
    case '105':
      marketType = MARKETTYPE.LOVE
      break
    case '101':
      marketType = MARKETTYPE.SFPARTWORK
      break
    case '4':
      marketType = MARKETTYPE.MUSKDOGE
      break
    case '8':
      marketType = MARKETTYPE.ONEINCH
      break
    case '5':
      marketType = MARKETTYPE.MEME
      break
  }
  return marketType
}
